import { render, staticRenderFns } from "./PuzzleNumberSquareEdit.vue?vue&type=template&id=e4297a8a"
import script from "./PuzzleNumberSquareEdit.vue?vue&type=script&lang=js"
export * from "./PuzzleNumberSquareEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports